export enum ContentType {
  FAQ = 'faq',
  TERMS_AND_CONDITIONS = 'terms_and_conditions',
  PRIVACY_POLICY = 'privacy_policy',
}
